import { languageHelper } from "../../../config/helperFunctions";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { apiKey } from "../../../config/config";
import MessageCard from "../../../components/AdminCards/MessageCard";

function ExpenseDetails({ general }) {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [data, setData] = useState();
  const [error, setError] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    const fetchExpenseCat = () => {
      axios
        .get(`${apiKey}/api/rms/admin/expense/${id}`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          setData(res.data);
        })
        .catch((err) => {
          setError(err.response.data?.message);
        })
        .finally(() => setPageLoading(false));
    };
    fetchExpenseCat();
  }, [id, user?.token]);

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }

  if (error) {
    return <MessageCard error={error} />;
  }

  return (
    <div>
      <div className="max-w-md mx-auto bg-white shadow-lg rounded-lg p-6 mt-10">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold text-purple-700">
            {general?.restaurant_name}
          </h1>
          <p className="text-gray-600">{general?.address}</p>
          <p className="text-sm text-gray-500">Tel: {general?.phone}</p>
        </div>

        <div className="border-t border-gray-300 pt-4">
          <p className="text-sm text-gray-600">{languageHelper("Tax Registration No")}</p>
          <h2 className="text-lg font-semibold text-gray-700">
            {general?.tax_reg_no}
          </h2>
        </div>

        <div className="mt-4 space-y-2">
          <div className="flex justify-between">
            <span className="text-gray-600">Date:</span>
            <span className="font-medium text-gray-800">{data?.date}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Amount:</span>
            <span className="font-medium text-gray-800">{data?.amount}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">VAT Percentage:</span>
            <span className="font-medium text-gray-800">{data?.vat_percentage}%</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">VAT:</span>
            <span className="font-medium text-gray-800">{data?.vat}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Total Amount:</span>
            <span className="font-medium text-gray-800">{data?.total_amount}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Tax Method:</span>
            <span className="font-medium text-gray-800">{data?.tax_method}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Category:</span>
            <span className="font-medium text-gray-800">{data?.category.name}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Payment Method:</span>
            <span className="font-medium text-gray-800">{data?.payment_method.name}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Responsible Person:</span>
            <span className="font-medium text-gray-800">{data?.employee.name}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Reference No:</span>
            <span className="font-medium text-gray-800">{data?.reference}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Invoice Number:</span>
            <span className="font-medium text-gray-800">{data?.invoice_reference || "-"}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Invoice Date:</span>
            <span className="font-medium text-gray-800">{data?.invoice_date || "-"}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Note:</span>
            <span className="font-medium text-gray-800">{data?.note || "-"}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Added By:</span>
            <span className="font-medium text-gray-800">{data?.user.name}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExpenseDetails;
